export const formList = [
  {
    field: 'reimNo',
    label: '报销单号'
  }, {
    field: 'expenseType',
    label: '费用类型',
    fieldType: 'expenseType'
  }, {
    field: 'status',
    label: '单据状态',
    fieldType: 'status'
  }, {
    field: 'reimAmount',
    label: '金额',
    fieldType: 'money'
  }, {
    field: 'reimApplicant',
    label: '报销人'
  }, {
    field: 'deptName',
    label: '部门'
  }, {
    field: 'createUserName',
    label: '提交人'
  }, {
    field: 'submitTime',
    label: '提交时间'
  }, {
    field: 'reimReason',
    label: '事由'
  }
]

export const formExamineInfo = [
  {
    field: 'reimNo',
    label: '报销单号'
  }, {
    field: 'expenseType',
    label: '费用类型',
    fieldType: 'expenseType'
  }, {
    field: 'reimStatus',
    label: '单据状态',
    fieldType: 'reimStatus'
  }, {
    field: 'reimAmount',
    label: '金额',
    fieldType: 'money'
  }, {
    field: 'reimApplicant',
    label: '报销人'
  }, {
    field: 'deptName',
    label: '部门'
  }, {
    field: 'reimReason',
    label: '事由'
  }, {
    field: 'remark',
    label: '备注'
  }
]

export const invoiceInfo = [
  {
    field: 'invoiceType',
    label: '发票类型',
    fieldType: 'invoiceType'
  }, {
    field: 'drewDate',
    label: '开票日期'
  }, {
    field: 'amountWithTax',
    label: '价税合计',
    fieldType: 'money'
  }, {
    field: 'invoiceCode',
    label: '发票代码'
  }, {
    field: 'amount',
    label: '金额(不含税)',
    fieldType: 'money'
  }, {
    field: 'invoiceNo',
    label: '发票号码'
  }, {
    field: 'taxAmount',
    label: '税额',
    fieldType: 'money'
  }
]

// 待办结果，UNHANDLED未处理，AGREE同意，REJECT驳回，REFERRAL转审，REVOKE撤回，ABO
export const handlerResultMap = {
  'AGREE': '已通过'
}
/**
 * 审批类型映射 审批类型: 或签、会签、依次审批
 */
export const examineTypeMap = {
  'OR_SIGN': '或签',
  'COUNTERSION': '会签',
  'APPROVE_IN_SEQUENCE': '依次审批'
}
// 待办结果，UNHANDLED未处理，AGREE同意，REJECT驳回，REFERRAL转审，REVOKE撤回，ABO
export const handlerResultClassMap = {
  'UNHANDLED': 'warning',
  'AGREE': 'success',
  'REJECT': 'error',
  'REFERRAL': 'warning',
  'REVOKE': 'error'
}
// 待办结果，UNHANDLED未处理，AGREE同意，REJECT驳回，REFERRAL转审，REVOKE撤回，ABO
export const mainResultTextMap = {
  'UNHANDLED': '未处理',
  'AGREE': '审批通过',
  'REJECT': '审批驳回',
  'FINISHED': '已完成',
  'REFERRAL': '已转审',
  'REVOKE': '审批撤回'
}

// 已审批主列表的图标
export const mainResultIconMap = new Map([
  ['UNHANDLED', { icon: '\ue6f7', color: '#ff943d' }], // 待审批
  ['AGREE', { icon: '\ue6f4', color: '#1EB665' }], // 通过
  ['REJECT', { icon: '\ue6f6', color: '#F7533F' }], // 驳回
  ['FINISHED', { icon: '\ue6f1', color: '#1EB665' }], // 已完成
  ['REFERRAL', { icon: '\ue6f4', color: '#1EB665' }], // 转审
  ['REVOKE', { icon: '\ue6f5', color: '#F7533F' }], // 撤回
  ['RUNNING', { icon: '\ue6f8', color: '#ff943d' }] // 审批中
])

// 待办结果，UNHANDLED未处理，AGREE同意，REJECT驳回，REFERRAL转审，REVOKE撤回，ABO
export const examineIconMap = new Map([
  ['0', { icon: '\ue6b7', color: '#1EB665' }],
  ['AGREE', { icon: '\ue6b7', color: '#1EB665' }],
  ['REJECT', { icon: '\ue6ba', color: '#F7533F' }],
  ['FINISHED', { icon: '\ue6b7', color: '#1EB665' }], // 已完成
  ['REFERRAL', { icon: '\ue6b7', color: '#1EB665' }],
  ['REVOKE', { icon: '\ue6ba', color: '#F7533F' }],
  ['RUNNING', { icon: '\ue6bc', color: '#ff943d' }]
])
